module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "tag-list"
  }, _vm._l((_vm.value), function(tag) {
    return _c('li', {
      staticClass: "tag"
    }, [(tag.href) ? _c('router-link', {
      staticClass: "tag-inner",
      attrs: {
        "to": tag.href
      }
    }, [_vm._v("\n      " + _vm._s(tag.name) + "\n    ")]) : _c('div', {
      staticClass: "tag-inner"
    }, [_vm._v("\n      " + _vm._s(tag.name) + "\n    ")])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67ac97be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/tag-list/index.vue
// module id = 2063
// module chunks = 2